import { useEffect, useState, useCallback } from "react";
import { getCurrentUser } from "../ctapi/users";
import { auth } from "../firebase/firebase";

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(() => {
    const storedUser = localStorage.getItem("firebaseUser");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const signOut = async () => {
    try {
      await auth.signOut();
      setUser(null);
      localStorage.removeItem("firebaseUser");
    } catch (error) {
      console.log("error signing out:", error);
    }
  };

  const fetchAndSetUser = useCallback(async () => {
    try {
      const firebaseUser = auth.currentUser;
      if (!firebaseUser) {
        setUser(null);
        setIsLoading(false);
        return;
      }

      const { accessToken } = firebaseUser;
      const user = await getCurrentUser(accessToken);
      
      setUser({
        ...user,
        is_verified: user.is_verified, 
        subscriptionStatus: user.subscriptionStatus ?? null,
        subscriptionTier: user.subscriptionTier ?? null,
        email: user.email ?? null,
        user_uuid: user.uuid,
      });

    } catch (error) {
      console.error("Error fetching user data:", error);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const refreshUser = async () => {
    setIsLoading(true);
    await fetchAndSetUser();
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        localStorage.setItem("firebaseUser", JSON.stringify(firebaseUser));
        setIsAuth(firebaseUser);
        setIsLoading(true); 
        fetchAndSetUser();
      } else {
        localStorage.removeItem("firebaseUser");
        setIsAuth(null);
        setUser(null);
        setIsLoading(false);
      }
    });

    return () => unsubscribe();
  }, [fetchAndSetUser]); 

  return { user, signOut, isAuth, isLoading, refreshUser }; 
};

export default useAuth;